module.exports = __webpack_public_path__ + "img/ywcj-jjfa_cylyh.e2a64e18.png";